import React from 'react';
import { BackgroundReportButton } from './BackgroundReportButton';

export const JingleReportButton = ({ token }) => (
  <BackgroundReportButton token={token} endpoint="jingle-misclass-report" label="Αναφορά jingle"
    filePrefix="jingle-misclass-report" dayOptions={[1, 3, 7]} testId="jingle-report" />
);
